import { render, staticRenderFns } from "./iDSRoot.vue?vue&type=template&id=ffde986c"
import script from "./iDSRoot.vue?vue&type=script&lang=js"
export * from "./iDSRoot.vue?vue&type=script&lang=js"
import style0 from "./iDSRoot.vue?vue&type=style&index=0&id=ffde986c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports